import * as React from 'react';
import {IControlError, IControlSchema} from '../../../Controls';
import { ApiClient } from '../../../../services/ApiClient';
import { IDispatcher } from '../../extensions/Dispatcher';
import RangeCalendar, {IRangeCalendarSchema} from './RangeCalendar';
import Calendar, {ICalendarSchema} from './Calendar';

export function createCalendar(schema: IControlSchema, api: ApiClient, dispatcher: IDispatcher = null, error: IControlError | undefined, visited: boolean): React.ReactElement<any> {
    let sh = schema as ICalendarSchema;
    return sh.finishDate !== null 
        ? (<RangeCalendar schema={schema as IRangeCalendarSchema}
            api={api}
            error={error}
            visited={visited}
            dispatcher={dispatcher} />)
        : (<Calendar schema={schema as ICalendarSchema}
            api={api}
            error={error}
            visited={visited}
            dispatcher={dispatcher} />)
}


// WEBPACK FOOTER //
// ./src/components/controls/standart/Calendar/index.tsx